import feathers from 'feathers-client'
import authentication from 'feathers-authentication-client'
import io from 'socket.io-client'

// TODO: Get these values from a reasonable location:
const host = `${document.location.protocol}//${document.location.hostname}:3030`;
const transporter = feathers.socketio(io(host));
const hooks = feathers.hooks();

// TODO: What the hell is this actually supposed to be:
const auth = authentication({ storage: window.localStorage});

const app = feathers()
  .configure(hooks)
  .configure(transporter)
  .configure(auth);

export default app



// WEBPACK FOOTER //
// ./src/feathers/index.js